/* Show / hide the vertical filter sidebar.

   Only runs where there is a sidebar to hide, i.e. collections on the
   sports-collection template. Everywhere else the query finds nothing and
   this exits.

   The button is injected rather than added to blocks/filters.liquid, which
   is a 40KB Horizon file we would rather not fork for one control - and a
   fork would have to be re-applied on every theme update.

   The choice is remembered per browser, because someone comparing teams
   should not have to re-collapse the column on every collection. It is a
   convenience, not state anything depends on, so every localStorage call
   is wrapped: private windows and blocked site data throw on access, and
   an exception here would leave the page with no toggle at all.

   Horizon replaces the whole facets form when a filter changes, so a
   MutationObserver re-mounts the button and re-applies the class.
*/
(function () {
  'use strict';

  var KEY = 'xs:filters-hidden';
  var ICON =
    '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" ' +
    'stroke-linecap="round" aria-hidden="true">' +
    '<path d="M3 6h14M3 10h14M3 14h14"/>' +
    '<circle cx="7" cy="6" r="2" fill="currentColor" stroke="none"/>' +
    '<circle cx="13" cy="10" r="2" fill="currentColor" stroke="none"/>' +
    '<circle cx="8" cy="14" r="2" fill="currentColor" stroke="none"/>' +
    '</svg>';

  function readStored() {
    try { return window.localStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }

  function writeStored(hidden) {
    try { window.localStorage.setItem(KEY, hidden ? '1' : '0'); } catch (e) { /* ignore */ }
  }

  function apply(wrapper, hidden) {
    wrapper.classList.toggle('xs-nofilters', hidden);
    var buttons = wrapper.querySelectorAll('.xs-filter-toggle');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-expanded', hidden ? 'false' : 'true');
      var text = buttons[i].querySelector('.xs-filter-toggle__text');
      if (text) text.textContent = hidden ? 'Show filters' : 'Hide filters';
    }
  }

  function mount() {
    var wrapper = document.querySelector('.collection-wrapper');
    if (!wrapper) return;

    /* No sidebar on this template - nothing to toggle. */
    var sidebar = wrapper.querySelector(
      '.facets-block-wrapper--vertical:not(.facets-block-wrapper--drawer)'
    );
    if (!sidebar) return;

    var bar = wrapper.querySelector('.facets-controls-wrapper');
    if (!bar) return;

    if (!bar.querySelector('.xs-filter-toggle')) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'xs-filter-toggle';
      button.setAttribute('aria-controls', 'xs-filter-sidebar');
      button.innerHTML = '<span class="xs-filter-toggle__text">Hide filters</span>' + ICON;
      button.addEventListener('click', function () {
        var next = !wrapper.classList.contains('xs-nofilters');
        apply(wrapper, next);
        writeStored(next);
      });

      sidebar.id = sidebar.id || 'xs-filter-sidebar';

      /* Sits with Sort and the density picker in the right-hand group;
         the count before it carries margin-inline-start:auto. */
      var sorting = bar.querySelector('sorting-filter-component, .sorting-filter');
      if (sorting) bar.insertBefore(button, sorting);
      else bar.appendChild(button);
    }

    apply(wrapper, readStored());
  }

  var timer = null;
  function schedule() {
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(function () { timer = null; mount(); }, 50);
  }

  schedule();
  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);
  document.addEventListener('shopify:section:load', schedule);

  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches('.facets-controls-wrapper, .collection-wrapper') ||
              node.querySelector('.facets-controls-wrapper')) {
            schedule();
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
}());